var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"text-muted"},[_vm._v("Saldo")]),_c('h4',{staticClass:"d-flex mb-0 font-weight-bold"},[(_vm.showBalance && !_vm.loading)?_c('span',[_vm._v("R$ "+_vm._s(_vm.balance))]):(_vm.loading)?_c('b-skeleton',{attrs:{"width":"100%"}}):(!_vm.showBalance)?_c('h3',[_c('i',{staticClass:"mdi mdi-eye-off text-muted"})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }